/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmVectorStoresDeleteFile } from "../../funcs/llmVectorStoresDeleteFile.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteVectorStoreFileRequest$inboundSchema,
};

export const tool$llmVectorStoresDeleteFile: ToolDefinition<typeof args> = {
  name: "llm-vector-stores-delete-file",
  description: `Remove file from vector store

Removes a file from a vector store and deletes its associated embeddings.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmVectorStoresDeleteFile(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
